import { render, staticRenderFns } from "./editReleaseDtu.vue?vue&type=template&id=26161aed&scoped=true"
import script from "./editReleaseDtu.vue?vue&type=script&lang=js"
export * from "./editReleaseDtu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26161aed",
  null
  
)

export default component.exports